import dayjs from 'dayjs';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { RouteLocationType } from '@/types/RouteLocationType';
import type { RoutesState } from '@/types/RoutesState';
import { TimeType } from '@/types/TimeType';

export const useRoutesStore = create<RoutesState>()(
  persist(
    (set) => ({
      routeLocations: {
        [RouteLocationType.ORIGIN]: undefined,
        [RouteLocationType.DESTINATION]: undefined,
      },

      time: {
        type: TimeType.DEPARTURE,
        date: dayjs(),
      },

      actions: {
        updateRouteLocations: ({ routeLocationType, location }) =>
          set(({ routeLocations }) => ({
            routeLocations: {
              ...routeLocations,
              [routeLocationType]: location && {
                ...location,
                properties: { ...location.properties, routeLocationType },
              },
            },
          })),

        updateTime: (updatedValues) =>
          set(({ time }) => ({
            time: {
              ...time,
              ...updatedValues,
            },
          })),
      },
    }),
    {
      name: 'DATSIM/ROUTES',
      version: 1,
      partialize: ({ actions, time, ...rest }) => rest,
    },
  ),
);
